import mobx, { observable, action, computed, autorun } from 'mobx';
import api from '../../api';
import accountStore from '../accountStore';
import appStore from '../appStore';
import Toto from './toto';
import Bet from './bet';
import Result from './result';
import Cards from './cards';
import Previous from './previous';
import Cardsall from './cardsall';

export class TotoStore {

	@observable isLoading = 0;
	@observable currencyId = 0;
	@observable currency = {};
	@observable result = {
		status: 0,
		text: '',
		type: 0
	};

	@observable Toto = null;
	@observable Bet = null;
	@observable Result = null;
	@observable Cards = null;
	@observable Previous = null;
	@observable Cardsall = null;
	
	constructor() {
		this.Toto = new Toto(this, accountStore, appStore);
		this.Bet = new Bet(this);
		this.Result = new Result(this);
		this.Cards = new Cards(this);
		this.Previous = new Previous(this);
		this.Cardsall = new Cardsall(this);
		autorun(() => {
			this.currency = appStore.financeData;
			this.currencyId = appStore.currency_id;
		});
	}

	@action selectCurrency(v) {
		this.currencyId = v;
	}

	@computed get current() {
		return this.currency[this.currencyId];
	}

	@action setResult(text, type) {
		this.result.status = 1;
		this.result.text = text;
		this.result.type = type ? type : 0;
	}

	@action clearResult() {
		this.result.status = 0;
		this.result.text = '';
		this.result.type = 0;
	}

	// @action initPage(route) {
	// 	this.isLoading = 0;
	// 	switch(route) {
	// 		case 'toto':
	// 			this.Toto.init();
	// 			break;
	// 		case 'bet':
	// 			this.Bet.init();
	// 			break;
	// 	}
	// }

}

export default new TotoStore();


// WEBPACK FOOTER //
// ./src/stores/totoStore/index.js